export default __webpack_public_path__ + "static/media/ps_01.dedb546b.png";